import { render, staticRenderFns } from "./CandidateReviewButtons.html?vue&type=template&id=d20ce1b4&scoped=true&external"
import script from "./CandidateReviewButtons.js?vue&type=script&lang=js&external"
export * from "./CandidateReviewButtons.js?vue&type=script&lang=js&external"
import style0 from "./CandidateReviewButtons.scss?vue&type=style&index=0&id=d20ce1b4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ce1b4",
  null
  
)

export default component.exports